import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Button from "components/atoms/Button";
import PageTitle from "components/atoms/PageTitle";
import Toggle from "components/atoms/Toggle";
import ChangePassword from "../ModalComponents/ChangePassword";
import Configure2FA from "../ModalComponents/Configure2FA";
import { BASE_URL, getRequest, postRequest } from "services/http";
import Alert from "components/atoms/Alert";
import refresh from "../../../assets/svg/refresh.svg";
import logoutIcon from "../../../assets/svg/logout_linear.svg";
import editIcon_w from "../../../assets/svg/edit-white.svg";
import editIcon_b from "../../../assets/svg/edit-black.svg";
import { handleLogout } from "utils";
import { Modal } from "rsuite";
import EditSettlement from "../ModalComponents/EditSettlement";
import EditKYCinfo from "../ModalComponents/EditKYCinfo";
import { useDispatch } from "react-redux";
import { SET_USER_AUTH_DATA } from "redux/auth/auth.type";

const Settings = (props) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [config2faRes, setConfig2faRes] = useState<any>();
  const [twoFAStatus, setTwoFAStatus] = useState(
    props.user_authData.mfAConfigured
  );
  const [modalId, setModalId] = useState("");

  const dispatch = useDispatch();

  const mfaURL = `${BASE_URL + "api/v1/mfa/"}`;

  const handleModal = (e) => {
    setShowModal((prevState) => !prevState);
    setModalId(e.target.id);
  };

  const requestOTPfor2FA = async () => {
    setLoading(true);
    const res = await postRequest(`${mfaURL}create`, {
      "Content-Type": "application/json",
      Authorization: `Bearer ${props.bearerToken}`,
    });

    if (res?.data.responseCode === "00") {
      Alert("success", res?.data?.message);
      setConfig2faRes(true);
      setLoading(false);
      dispatch({
        type: SET_USER_AUTH_DATA,
        payload: {
          multiFactorAuthentication: true,
          mfAConfigured: true
        }
      })
    } else {
      res?.data?.message !== undefined && Alert("error", res?.data?.message);
      setConfig2faRes(false);
      setShowModal(false);
      setLoading(false);
    }
  };

  const toggle2faConfig = async (reqUrl: any) => {
    setLoading(true);
    const res = await postRequest(`${mfaURL + reqUrl}`, {
      "Content-Type": "application/json",
      Authorization: `Bearer ${props.bearerToken}`,
    });

    if (res?.data.responseCode === "00") {
      setTimeout(() => {
        Alert("success", res?.data?.message);
        setTwoFAStatus((prevState: boolean) => !prevState);
        setLoading(false);
      }, 1500);
    } else {
      setLoading(false);
    }
  };

  // twoFAStatus
  //   ? () => toggle2faConfig("disable")
  //   : () => toggle2faConfig("enable");

  const update2FAStatus = () => {
    if (twoFAStatus) {
      toggle2faConfig("disable");
      dispatch({
        type: SET_USER_AUTH_DATA,
        payload: {
          multiFactorAuthentication: true,
          mfAConfigured: false,
        },
      });
    } else if (!twoFAStatus) {
      toggle2faConfig("enable");
      dispatch({
        type: SET_USER_AUTH_DATA,
        payload: {
          multiFactorAuthentication: true,
          mfAConfigured: true,
        },
      });
    }
  };

  useEffect(() => {
    if (modalId === "2fa_modal" && showModal) {
      setTimeout(() => {
        Alert("info", "Requesting 2FA Configuration");
        requestOTPfor2FA();
      }, 1000);
    }
  }, [modalId]);

  return (
    <div className="w-full min-h-[90vh] mobile:min-h-[83vh] h-fit flex flex-col justify-start gap-10 mobile:pb-10">
      <PageTitle pageTitle="Settings" pageTitleStyle="" />
      <div className="flex items-start justify-between w-11/12 gap-24 tablet:gap-10 tablet:flex-col tablet:w-full desktop:px-10">
        <div className="flex flex-col w-4/5 gap-16 mobile:w-full tablet:gap-10">
          <div className="flex flex-col gap-1">
            <div className="flex items-center justify-between gap-5">
              <PageTitle
                pageTitle="Partner Details"
                pageTitleStyle="!text-[18px] !leading-[30px] !mt-0 !mb-0"
              />

              {/* <Button
                                btnId='edit_partner_details'
                                btnType='button'
                                btnText='Edit'
                                btnStyle='border border-DarkBg3 text-DarkBg3 font-normal !text-sm mobile:!text-xs leading-5 py-2 px-5 min-w-[100px] mobile:min-w-fit'
                                btnImg={editIcon_b}
                                btnImgStyle='w-4 h-4'
                                onClick={handleModal}
                            /> */}
            </div>

                        <div className='flex flex-col gap-2'>
                            <span className='border-b py-3 flex justify-between items-center gap-5'>
                                <p className='font-normal text-sm mobile:text-xs leading-[30px] text-SecondaryAccent'>Partner Name</p>
                                <p className='font-normal text-base mobile:text-sm leading-[20px]'>{`${props.user_authData.partnerBusinessName || "-"}`}</p>
                            </span>
                            <span className='border-b py-3 flex justify-between items-center gap-5'>
                                <p className='font-normal text-sm mobile:text-xs leading-[30px] text-SecondaryAccent'>First Name</p>
                                <p className='font-normal text-base mobile:text-sm leading-[20px]'>{`${props.user_authData.first_name || "-"}`}</p>
                            </span>
                            <span className='border-b py-3 flex justify-between items-center gap-5'>
                                <p className='font-normal text-sm mobile:text-xs leading-[30px] text-SecondaryAccent'>Last Name</p>
                                <p className='font-normal text-base mobile:text-sm leading-[20px]'>{`${props.user_authData.last_name || "-"}`}</p>
                            </span>
                            <span className='border-b py-3 flex justify-between items-center gap-5'>
                                <p className='font-normal text-sm mobile:text-xs leading-[30px] text-SecondaryAccent'>Business Email</p>
                                <p className='font-normal text-base mobile:text-sm leading-[20px]'>{`${props.user_authData.partnerEmail || "-"}`}</p>
                            </span>
                            {/* <span className='border-b py-3 flex justify-between items-center gap-5'>
                                <p className='font-normal text-sm mobile:text-xs leading-[30px] text-SecondaryAccent'>Phone Number</p>
                                <p className='font-normal text-base mobile:text-sm leading-[20px]'>{`${props.user_authData.phoneNumber || "NA"}`}</p>
                            </span> */}
                            <span className='border-b py-3 flex justify-between items-center gap-5'>
                                <p className='font-normal text-sm mobile:text-xs leading-[30px] text-SecondaryAccent'>Street</p>
                                <p className='font-normal text-base mobile:text-sm leading-[20px]'>{`${props.user_authData.address?.street || "-"}`}</p>
                            </span>
                            <span className='border-b py-3 flex justify-between items-center gap-5'>
                                <p className='font-normal text-sm mobile:text-xs leading-[30px] text-SecondaryAccent'>City, State</p>
                                <p className='font-normal text-base mobile:text-sm leading-[20px]'>{`${props.user_authData.address?.city || "-"}, ${props.user_authData.address?.state || "-"}`}</p>
                            </span>
                        </div>
                    </div>
                    <div className='flex flex-col gap-1'>
                        <div className='flex justify-between items-center gap-5'>
                            <PageTitle
                                pageTitle='Settlement Details'
                                pageTitleStyle='!text-[18px] !leading-[30px] !mt-0 !mb-0'
                            />

                            {!props.user_authData.partnerApproved &&
                                <Button
                                    btnId='edit_settlement'
                                    btnType='button'
                                    btnText='Edit'
                                    btnStyle='border border-DarkBg3 text-DarkBg3 font-normal !text-sm mobile:!text-xs leading-5 py-2 px-5 min-w-[100px] mobile:min-w-fit'
                                    btnImg={editIcon_b}
                                    btnImgStyle='w-4 h-4'
                                    onClick={handleModal}
                                />
                            }
                        </div>
                        <div className='flex flex-col gap-2'>
                            <span className='border-b py-3 flex justify-between items-center gap-5'>
                                <p className='font-normal text-sm mobile:text-xs leading-[30px] text-SecondaryAccent'>Bank Name</p>
                                <p className='font-normal text-base mobile:text-sm leading-[20px]'>{`${props.user_authData.settlement_account?.payout_bank_name || "-"}`}</p>
                            </span>
                            <span className='border-b py-3 flex justify-between items-center gap-5'>
                                <p className='font-normal text-sm mobile:text-xs leading-[30px] text-SecondaryAccent'>Account Number</p>
                                <p className='font-normal text-base mobile:text-sm leading-[20px]'>{`${props.user_authData.settlement_account?.payout_account_number || "-"}`}</p>
                            </span>
                            <span className='border-b py-3 flex justify-between items-center gap-5'>
                                <p className='font-normal text-sm mobile:text-xs leading-[30px] text-SecondaryAccent'>Account Name</p>
                                <p className='font-normal text-base mobile:text-sm leading-[20px]'>{`${props.user_authData.settlement_account?.payout_account_name || "-"}`}</p>
                            </span>
                        </div>
                    </div>
                </div>
                <div className='w-4/5 mobile:w-full flex flex-col gap-16 tablet:gap-10'>
                    {/* <div className='flex flex-col gap-1'>
                        <div className='flex justify-between items-center gap-5'>
                            <PageTitle
                                pageTitle='KYC Details'
                                pageTitleStyle='!text-[18px] !leading-[30px] !mt-0 !mb-0'
                            />

                            {!props.user_authData.partnerApproved &&
                                <Button
                                    btnId='edit_kyc_info'
                                    btnType='button'
                                    btnText='Edit'
                                    btnStyle='border border-DarkBg3 text-DarkBg3 font-normal !text-sm mobile:!text-xs leading-5 py-2 px-5 min-w-[100px] mobile:min-w-fit'
                                    btnImg={editIcon_b}
                                    btnImgStyle='w-4 h-4'
                                    onClick={handleModal}
                                />
                            }
                        </div>
                        <div className='flex flex-col gap-2'>
                            <span className='flex items-center justify-between gap-5 py-3 border-b'>
                                <p className='font-normal text-sm mobile:text-xs leading-[30px] text-SecondaryAccent'>BVN</p>
                                <p className='font-normal text-base mobile:text-sm leading-[20px]'>{`${props.user_authData.settlement_account?.payout_bvn_number}`}</p>
                            </span>
                            <span className='flex items-center justify-between gap-5 py-3 border-b'>
                                <p className='font-normal text-sm mobile:text-xs leading-[30px] text-SecondaryAccent'>Partner Name</p>
                                <p className='font-normal text-base mobile:text-sm leading-[20px]'>{`${props.user_authData.partnerBusinessName}`}</p>
                            </span>
                        </div>
                    </div> */}

          <div className="flex flex-col gap-1">
            <PageTitle
              pageTitle="Security"
              pageTitleStyle="!text-[18px] !leading-[30px] !mt-0 !mb-0"
            />
            <div className="flex flex-col gap-2">
              {!props.user_authData.multiFactorAuthentication ? (
                <span className="pt-3 pb-1 border-b">
                  <div className="flex items-center justify-between gap-5">
                    <p className="font-normal text-sm mobile:text-xs leading-[30px] truncate">
                      Configure TWO-Factor Authentication
                    </p>
                    <Button
                      btnId="2fa_modal"
                      btnType="button"
                      btnText="Configure 2FA"
                      btnStyle="bg-DarkBg3 text-white font-normal !text-sm mobile:!text-xs leading-5 py-2 px-5 min-w-[100px] mobile:min-w-fit"
                      onClick={handleModal}
                    />
                  </div>
                  <div className="font-normal text-xs mobile:text-xs leading-[20px] text-BackDrop_d_md">
                    <p>
                      This User isn't Configured for Two-Factor Authentication
                    </p>
                  </div>
                </span>
              ) : (
                <span className="pt-3 pb-1 border-b">
                  <div className="flex items-center justify-between gap-5">
                    <p className="font-normal text-sm mobile:text-xs leading-[24px] truncate">
                      Two-Factor Authentication
                    </p>
                    <div className="relative flex items-center justify-center gap-3">
                      {loading && (
                        <img
                          src={refresh}
                          alt="loader"
                          className="w-4 h-4 animate-fullRoll absolute -right-8 mobile:-left-5 top-[2px]"
                        />
                      )}
                      <Toggle
                        handleClick={() => update2FAStatus()}
                        checked={twoFAStatus}
                        style="w-[26px] h-[14px] after:h-3 after:w-3 after:top-0 after:bottom-0 after:left-[1px] after:my-auto peer-checked:bg-black after:bg-GrayCustom6"
                        notifyMssg={twoFAStatus ? "Enabled" : "Disabled"}
                        notifyMssgStyle={twoFAStatus && "text-Success"}
                        disapperMssg={true}
                      />
                    </div>
                  </div>
                  <div className="font-normal text-xs mobile:text-xs leading-[20px] text-BackDrop_d_md">
                    {props.user_authData.mfAConfigured ? (
                      <p>
                        2 Factor Authentication is Configured and currently
                        Enabled.
                      </p>
                    ) : (
                      <p>
                        2 Factor Authentication is Configured but currently
                        Disabled.
                      </p>
                    )}
                  </div>
                </span>
              )}
              <span className="flex items-center justify-between gap-5 py-3 border-b">
                <p className="font-normal text-sm mobile:text-xs leading-[30px] truncate">
                  Change Password
                </p>
                <Button
                  btnId="change_passwd_modal"
                  btnType="button"
                  btnText="Update Password"
                  btnStyle="bg-DarkBg3 text-white font-normal !text-sm mobile:!text-xs leading-5 px-5 py-2 min-w-[100px] mobile:min-w-fit"
                  btnImg={editIcon_w}
                  btnImgStyle="w-4 h-4"
                  onClick={handleModal}
                />
              </span>
              <span className="flex items-center justify-between gap-5 py-3 border-b">
                <p className="font-normal text-sm mobile:text-xs leading-[30px] truncate">
                  Log out
                </p>
                <Button
                  // btnId='change_passwd_modal'
                  btnType="button"
                  btnText="Log out"
                  btnStyle="bg-DarkBg3 text-white font-normal !text-sm mobile:!text-xs leading-5 px-5 py-2 min-w-[100px] mobile:min-w-fit"
                  btnImg={logoutIcon}
                  btnImgStyle="w-4 h-4"
                  onClick={handleLogout}
                />
              </span>
            </div>
          </div>
        </div>
      </div>

      {showModal && modalId === "change_passwd_modal" ? (
        <ChangePassword setShowModal={setShowModal} />
      ) : showModal && modalId === "2fa_modal" ? (
        <Configure2FA setShowModal={setShowModal} status={config2faRes} />
      ) : showModal && modalId === "edit_settlement" ? (
        <EditSettlement setShowModal={setShowModal} />
      ) : showModal && modalId === "edit_kyc_info" ? (
        <EditKYCinfo setShowModal={setShowModal} />
      ) : (
        ""
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  two_factor_auth: state.auth.two_factor_auth,
  bearerToken: state.auth.user_authData?.token.token,
  user_authData: state.auth.user_authData,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
